import { convertToCommonErrors } from '../../common/utils/errorUtils.js';
import { TypeKeys, generateActionId } from './actionsUtils.js';
import type { CrudAction, ErrorAction } from './actionsUtils.js';
import type { SubscriptionCategory } from '../../common/enums.js';
import type { GenericError, SubscriptionsResponse } from '../../generated/api/models.js';
import type { Action } from 'redux';

// get user Subscriptions
export interface GetEmployeeSubscriptionsAction extends CrudAction<TypeKeys.GET_EMPLOYEE_SUBSCRIPTIONS> {
  subscriptionItemId?: string;
  subscriptionType: SubscriptionCategory;
}

export interface GetEmployeeSubscriptionsFulfilledAction extends Action {
  response: SubscriptionsResponse;
  subscriptionType: SubscriptionCategory;
  type: TypeKeys.GET_EMPLOYEE_SUBSCRIPTIONS_FULLFILLED;
  subscriptionItemId?: string;
}

export type GetEmployeeSubscriptionsFailedAction = ErrorAction<TypeKeys.GET_EMPLOYEE_SUBSCRIPTIONS_FAILED>;

export const getEmployeeSubscriptions = (
  subscriptionType: SubscriptionCategory,
  subscriptionItemId?: string
): GetEmployeeSubscriptionsAction => ({
  id: generateActionId(),
  subscriptionItemId,
  subscriptionType,
  type: TypeKeys.GET_EMPLOYEE_SUBSCRIPTIONS,
});

export const getEmployeeSubscriptionsFulfilled = (
  response: SubscriptionsResponse,
  subscriptionType: SubscriptionCategory,
  subscriptionItemId?: string
): GetEmployeeSubscriptionsFulfilledAction => ({
  response,
  subscriptionItemId,
  subscriptionType,
  type: TypeKeys.GET_EMPLOYEE_SUBSCRIPTIONS_FULLFILLED,
});

export const getEmployeeSubscriptionsFailed = (
  message: string,
  status: number,
  errors?: GenericError[],
  params?: { [s: string]: string }
): GetEmployeeSubscriptionsFailedAction => ({
  errors: convertToCommonErrors(message, status, errors),
  params,
  type: TypeKeys.GET_EMPLOYEE_SUBSCRIPTIONS_FAILED,
});

export interface CheckValidEmployeeSubscription extends CrudAction<TypeKeys.CHECK_VALID_EMPLOYEE_SUBSCRIPTION> {
  subscriptionType: string;
  subscriptionToValidate?: string;
}

export const checkValidEmployeeSubscription = (
  subscriptionType: SubscriptionCategory,
  subscriptionToValidate?: string
): CheckValidEmployeeSubscription => ({
  id: generateActionId(),
  subscriptionToValidate,
  subscriptionType,
  type: TypeKeys.CHECK_VALID_EMPLOYEE_SUBSCRIPTION,
});

export type UserActionTypes =
  | GetEmployeeSubscriptionsAction
  | GetEmployeeSubscriptionsFulfilledAction
  | GetEmployeeSubscriptionsFailedAction
  | CheckValidEmployeeSubscription;
